module.exports = __webpack_public_path__ + "static/media/ic-discount-green.ef96f3ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-discount-green.svg
// module id = 620
// module chunks = 14